import { IActionFn } from '@/store/types';
import { IModuleState } from './types';
import { $http } from '@/axios';
import { getStorage } from '@/utils/storage';
import store from '@/store';

// 查询价格矩阵配置
export const queryPriceMatrix: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setPriceMatrix', { ...state.priceMatrix, loading: true });
    const res = await $http.post('/v1/finance/service/pricematrix', payload);
    commit('setPriceMatrix', { data: res });
  } catch (e) {
    commit('setPriceMatrix', { data: [] });
  }
};

// 查询所有增值服务
export const queryModules: IActionFn<IModuleState> = async ({ commit, state }) => {
  try {
    // 能用这个功能的一定是平台用户，所以 orgId 一定是'平台'的组织ID
    const orgId = JSON.parse(getStorage('userInfo') || '{}').orgId;
    commit('setModules', { ...state.modules, loading: true });
    const res = await $http.post('/v1/system/module/list', { orgId });
    commit('setModules', { data: res });
  } catch (e) {
    commit('setModules', { data: [] });
  }
};

// 保存价格矩阵
export const savePriceMatrix: IActionFn<IModuleState> = async ({ commit, dispatch, state }, payload) => {
  try {
    commit('setLoading', true);
    await $http.post('/v1/finance/service/saveorupdatepricematrix', payload);
    store.commit('common/setToast', { visible: true, text: '保存成功' });
  } finally {
    commit('setLoading', false);
  }
};

// 删除价格矩阵(所有值保存为空，即是删除)
export const deletePriceMatrix: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setConfirm', { ...state.confirm, loading: true });
    await $http.post('/v1/finance/service/saveorupdatepricematrix', payload);
  } finally {
    commit('setConfirm', { visible: false });
  }
};

